module.exports = {"210603001":"头道桥街道","210603002":"站前街道","210603003":"临江街道","210603004":"六道沟街道","210603005":"帽盔山街道","210603006":"纤维街道","210603007":"永昌街道","210603008":"花园街道","210603009":"江海街道","210603010":"西城街道","210603101":"浪头镇","210603102":"安民镇","210603103":"汤池镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210603.json
// module id = 546
// module chunks = 0